<ng-container *ngIf="showFilters$ | async">
    <!-- Overlay -->
    <div class="fixed top-0 left-0 w-full h-full z-40 bg-black bg-opacity-50"></div>

    <!-- Pannello laterale con animazione -->
    <div [@slideInOut] class="fixed top-0 left-0 h-full w-full z-50">
        <app-search-product-filters></app-search-product-filters>
    </div>
</ng-container>
<div class="flex flex-col h-full">
    <div class="bg-light-linear rounded-t-4xl relative px-4 sm:px-6 xl:px-8 h-full pb-32 xl:pb-24">
        <div class="flex flex-col items-center justify-center w-full mt-5">
            <h1 class="text-primary font-semibold text-5xl">Marketplace</h1>
            <p class="mt-3 text-center">Benessere monitorato: il percorso giusto per i tuoi obiettivi</p>
        </div>

        <app-loader *ngIf="isLoading$ | async; else productsContainer"></app-loader>

        <ng-template #productsContainer>

            <div class="flex flex-row justify-between items-center my-10">
                <button (click)="toggleFilters()"
                        class="py-1 px-3 bg-white text-primary rounded-lg flex items-center justify-center border border-primary w-28">
                    <div class="flex items-center">
                        <svg class="size-5 fill-primary">
                            <use href="../assets/svg/svGP.svg#filter-list"></use>
                        </svg>
                        <span class="ms-2 font-medium">Filtra</span>
                    </div>
                </button>
                <div class="flex items-center">
                    <label class="text-595959 font-bold text-sm text-nowrap" for="orderProducts">
                        Ordina Per
                    </label>
                    <select id="orderProducts" tabindex="0" [(ngModel)]="sortType" (ngModelChange)="sortTypeChange()"
                            class="ms-2 form-control bg-white border border-primary text-text-color text-sm rounded-lg focus:ring-primary block w-full p-1 max-w-28 h-8">
                        <option [ngValue]="null">Default</option>
                        <option [ngValue]="'price:asc'">Prezzo Crescente</option>
                        <option [ngValue]="'price:desc'">Prezzo Decrescente</option>
                    </select>
                </div>
            </div>

            <section *ngIf="isFilteredProductsEmpty$ | async; else filteredProductsSection">
                <div class="flex flex-col items-center justify-start px-4 text-center">
                    <svg class="size-40 text-primary mb-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121 120">
                        <path
                            d="M118.6 77.4c0-1.3-1.1-2.4-2.4-2.4H9.6c-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4h14.3c1.3 0 2.4 1.1 2.4 2.4s-1.1 2.4-2.4 2.4H21c-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4h8.5c1.3 0 2.4 1.1 2.4 2.4s-1.1 2.4-2.4 2.4h-3.8c-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4h58.1c1.3 0 2.4-1.1 2.4-2.4s-1.1-2.4-2.4-2.4H71c-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4h37.7c1.3 0 2.4-1.1 2.4-2.4s-1.1-2.4-2.4-2.4H96.1c-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4h20.2c1.3 0 2.4-1.1 2.4-2.4zM39.7 94.5c-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4h8c1.3 0 2.4 1.1 2.4 2.4s-1.1 2.4-2.4 2.4h-8z"
                            fill="#86af96" fill-rule="evenodd"/>
                        <path
                            d="M89.2 96.9c0-1.3 1.1-2.4 2.4-2.4h11.6c1.3 0 2.4 1.1 2.4 2.5 0 1.3-1.1 2.4-2.4 2.4H91.6c-1.3 0-2.4-1.1-2.4-2.4zm-76.1-9.7c0-1.3-1.1-2.4-2.4-2.4H4.8c-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4h5.9c1.3 0 2.4-1.1 2.4-2.4z"
                            fill="#86af96"/>
                        <path d="M30.8 48.2h29.3v32.3H30.8V48.2z" fill="#86af96" fill-opacity=".5"/>
                        <path
                            d="M30.8 48.2h29.3L52 39.4H22.7l8.1 8.8zm0 0v10.6H20.2l10.6-10.6zM60.1 48h33.6v27.2H60.1V48z"
                            fill="#577881"/>
                        <path d="M60.1 48.2h33.7l7.3 13.9H67.4l-7.3-13.9z" fill="#577881"/>
                        <path d="M60.1 48.2h33.7l7.3-6.6H67.4l-7.3 6.6z" fill="#86af96" fill-opacity=".5"/>
                        <path d="M35.2 54.4h15v3.8h-15v-3.8z" fill="#577881"/>
                        <path d="M24.9 26.4l6.1 5.7m5.9-10.5l1.5 7.3m58.2-2.5l-6.1 5.7m-5.9-10.5l-1.5 7.3" fill="none"
                              stroke="#577881" stroke-linecap="round" stroke-width="1.9"/>
                    </svg>
                    <h1 class="text-4xl font-bold mb-2">Nessun risultato trovato.</h1>
                    <p class="mb-6">Prova a modificare i filtri di ricerca</p>
                    <a (click)="navigateAndReload()"
                       class="bg-primary text-white px-6 py-2 rounded-lg hover:bg-primary-dark transition">
                        Rimuovi tutti i filtri di ricerca
                    </a>
                </div>
            </section>


            <ng-template #filteredProductsSection>
                @if (filteredProducts$ | async; as filteredProducts) {
                    @if (filteredProducts.featured.length > 0) {
                        <section class="marketplace-featured-section">
                            <h2 class="marketplace-section-title marketplace-section-title--featured">In evidenza</h2>
                            <div class="marketplace-featured-grid masonry__layout-container">
                                <div class="marketplace-featured-copy marketplace-featured-grid__hero masonry__layout">
                                    <div class="marketplace-featured-copy__inner">
                                        <div class="marketplace-featured-copy__eyebrow">
                                            <span class="marketplace-featured-copy__badge">Percorsi guidati</span>
                                        </div>
                                        <div class="marketplace-featured-copy__body">
                                            <div class="marketplace-featured-image-wrapper">
                                                <img src="../assets/img/illustrations/illustration-survey.png"
                                                     class="marketplace-featured-image" alt=""/>
                                            </div>
                                            <h3 class="font-bold text-3xl text-primary mt-6">Scegli come stare bene</h3>
                                            <p class="marketplace-featured-text">
                                                Trova il percorso più adatto a te. I nostri professionisti ti accompagneranno costantemente monitorando i tuoi progressi nel movimento, alimentazione, energia e mindset, per aiutarti a costruire abitudini più consapevoli e sostenibili.
                                            </p>
                                        </div>
                                        <div class="marketplace-featured-copy__footer">
                                            <span class="marketplace-featured-copy__chip">Movimento</span>
                                            <span class="marketplace-featured-copy__chip">Nutrizione</span>
                                            <span class="marketplace-featured-copy__chip">Mindset</span>
                                        </div>
                                    </div>
                                </div>
                                @for (product of filteredProducts.featured; track product.productCode) {
                                    <div class="marketplace-products-grid__item masonry__layout">
                                        <product-card [product]="product"/>
                                    </div>
                                }
                            </div>
                        </section>
                    }

                    @if (marketplaceSections$ | async; as marketplaceSections) {
                        @for (section of marketplaceSections; track section.key; let isFirst = $first) {
                            @if (filteredProducts.featured.length > 0 || !isFirst) {
                                <hr class="dashed fullscreen marketplace-section-divider"/>
                            }

                            <section class="marketplace-section">
                                <h2 class="marketplace-section-title">{{ section.title }}</h2>
                                @if (section.descriptionKey) {
                                    <p class="marketplace-section-description">
                                        {{ section.descriptionKey | transloco }}
                                    </p>
                                } @else if (section.description) {
                                    <p class="marketplace-section-description">
                                        {{ section.description }}
                                    </p>
                                }
                                <div class="marketplace-products-grid masonry__layout-container">
                                    @for (product of section.products; track product.productCode) {
                                        <div class="marketplace-products-grid__item masonry__layout">
                                            <product-card [product]="product"/>
                                        </div>
                                    }
                                </div>
                            </section>
                        }
                    }
                }
                <marketplace-footer class="hidden xl:block mt-16 mb-40"></marketplace-footer>
            </ng-template>
        </ng-template>
    </div>
</div>
